import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProcessProviderId } from '@fgb/core';

import * as ɵngcc0 from '@angular/core';
class LoyaltyIconComponent {
    constructor() {
        this.gIconAuction = 'gavel';
        this.gIconLotto = 'confirmation_number';
        this.gIconMarketplace = 'shopping_bag';
        this.gIconWallet = 'account_balance_wallet';
        this.gIconWalletRedeemed = 'shopping_bag';
        this.gIconMarketplaceFortressGb = 'shopping_bag';
        this.gIconMarketplaceUniqueCode = 'qr_code';
        this.gIconMarketplaceDownload = 'file_download';
        this.gIconMarketplaceEvent = 'local_activity';
        this.gIconMarketplacePortalProduct = 'local_atm';
        this.gIconMarketplaceVirtualEvent = 'local_activity';
    }
    ngOnInit() {
        switch (this.loyaltyType) {
            case 'auction':
                this.gIcon = this.gIconAuction;
                break;
            case 'lotto':
                this.gIcon = this.gIconLotto;
                break;
            case 'wallet':
                this.gIcon = this.gIconWallet;
                break;
            case 'walletRedeemed':
                this.gIcon = this.gIconWalletRedeemed;
                break;
            case ProcessProviderId.FortressGB:
                this.gIcon = this.gIconMarketplaceFortressGb;
                break;
            case ProcessProviderId.UniqueCode:
                this.gIcon = this.gIconMarketplaceUniqueCode;
                break;
            case ProcessProviderId.Download:
                this.gIcon = this.gIconMarketplaceDownload;
                break;
            case ProcessProviderId.Event:
                this.gIcon = this.gIconMarketplaceEvent;
                break;
            case ProcessProviderId.Product:
                this.gIcon = this.gIconMarketplacePortalProduct;
                break;
            case ProcessProviderId.VirtualEvent:
                this.gIcon = this.gIconMarketplaceVirtualEvent;
                break;
            default:
                this.gIcon = this.gIconMarketplace;
                break;
        }
    }
}
LoyaltyIconComponent.ɵfac = function LoyaltyIconComponent_Factory(t) { return new (t || LoyaltyIconComponent)(); };
LoyaltyIconComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LoyaltyIconComponent, selectors: [["fgbcl-loyalty-icon"]], inputs: { loyaltyType: "loyaltyType" }, decls: 2, vars: 1, consts: [["aria-hidden", "true", 1, "icon", "material-icons"]], template: function LoyaltyIconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.gIcon);
    } }, styles: [""] });
LoyaltyIconComponent.ctorParameters = () => [];
LoyaltyIconComponent.propDecorators = {
    loyaltyType: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoyaltyIconComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-loyalty-icon',
                template: "<span class=\"icon material-icons\" aria-hidden=\"true\">{{ gIcon }}</span>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { loyaltyType: [{
            type: Input
        }] }); })();

class LoyaltyIconModule {
}
LoyaltyIconModule.ɵfac = function LoyaltyIconModule_Factory(t) { return new (t || LoyaltyIconModule)(); };
LoyaltyIconModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LoyaltyIconModule });
LoyaltyIconModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LoyaltyIconModule, { declarations: function () { return [LoyaltyIconComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [LoyaltyIconComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoyaltyIconModule, [{
        type: NgModule,
        args: [{
                declarations: [LoyaltyIconComponent],
                imports: [CommonModule],
                exports: [LoyaltyIconComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { LoyaltyIconComponent, LoyaltyIconModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-shared-loyalty-icon.js.map